import { createConfig, createFlowContext } from '@betterment/shared-components';
import { Outlet } from 'react-router-dom';
import * as yup from 'yup';

const OWNERSHIP_TYPES = ['individual_taxable', 'joint_taxable', 'trust_taxable'] as const;

const existingTrustSchema = yup.object({
  id: yup.string().required(),
  displayName: yup.string().required(),
});

export const SDI_ACCOUNT_FLOW_CONFIG = createConfig({
  ownership: {
    schema: yup.object({
      ownershipType: yup.string().oneOf(OWNERSHIP_TYPES).required(),
      existingTrusts: yup.array().of(existingTrustSchema).required(),
    }),
    dependencies: yup.object({}),
  },
  trust: {
    schema: yup.object({
      selectedTrustId: yup.string().required(),
    }),
    dependencies: yup.object({}),
  },
});

export const { FlowProvider, useStep: useSdiAccountStep } = createFlowContext(SDI_ACCOUNT_FLOW_CONFIG);

export const SdiAccountFlow = () => (
  <FlowProvider>
    <Outlet />
  </FlowProvider>
);
